<template>
     
    <div class="content" style="margin:2%;height: auto;min-height: 150px;" v-if="losmasvistosprods.length>0">
        <!-- Triángulo en la esquina superior izquierda -->
        
        <div class="box">
            <div class="badge badge-top-right"><span>DESTACADO</span></div>
            <div class="row" style="margin-right: 0;margin-left: 0;padding-left:0;">
                <!-- Columna izquierda con imagen -->
                <div class="col-md-6 col-sm-12 nopadding">
                    <img :src="'img/banners/' + losmasvistosprods[0].image" alt="Imagen" style="width: 100%; height: 100%;" class="opacity-and-blur">
                    <!-- Este slot estará oculto, solo se utilizará para agregar texto -->
                </div>
                <!-- Columna derecha -->
                <div class="col-md-6 col-sm-12">
                    <!--<div class="row">
                        <slot name="right-content">Hola mundo</slot>
                    </div>-->
                    <div class="row">
                        <Carousel :value="losmasvistosprods[0].productos" :numVisible="1" :numScroll="1" orientation="vertical"
                            :autoplayInterval="2000" verticalViewPortHeight="250px"
                            contentClass="flex align-items-center">
                            <template #item="slotPropsUltimosVendidosHoy">
                                <div class="border-1 surface-border border-round m-2 p-3">
                                    <div class="flex justify-content-between align-items-center  badge-container">
                                        <div class="badge-placeholder"
                                            v-if="slotPropsUltimosVendidosHoy.data.especial && slotPropsUltimosVendidosHoy.data.especial !== 'False' && slotPropsUltimosVendidosHoy.data.especial !== 'false'">
                                            <span class="badge-vino-fino" style="font-size: 10px;">
                                                <i class="bx bx-crown" aria-hidden="true"></i>
                                                Recomendación para ti
                                            </span>
                                        </div>
                                        <div class="badge-placeholder">
                                            <span class="badge-vino-naranja" style="font-size: 10px;"
                                                v-if="slotPropsUltimosVendidosHoy.data.mejoresventas"><i
                                                    class="bx bx-award" aria-hidden="true"></i>&nbsp;Top
                                                Ventas</span>
                                            <span class="badge-vino-azul" style="font-size: 10px;"
                                                v-else-if="slotPropsUltimosVendidosHoy.data.mejoresventaslineas"><i
                                                    class="bx bx-star" aria-hidden="true"></i>&nbsp;Top
                                                Ventas
                                                Lineas</span>
                                        </div>
                                    </div>
                                    <div class="mb-3">
                                        <div class="relative mx-auto">
                                            <img v-if="slotPropsUltimosVendidosHoy.data.PicturesUrl && slotPropsUltimosVendidosHoy.data.PicturesUrl[slotPropsUltimosVendidosHoy.data.categorias[0].marcas.viewimagesprinc]"
                                                :src='slotPropsUltimosVendidosHoy.data.PicturesUrl[slotPropsUltimosVendidosHoy.data.categorias[0].marcas.viewimagesprinc].sm'
                                                class="w-full border-round" style="height: 100px;" />
                                            <img v-else :src="getImagePath('img/display/Placeholder.png')"
                                                class="w-full border-round" style="height: 100px;" />
                                        </div>
                                    </div>
                                    <div class="flex justify-content-between align-items-center">
                                        <div class="mt-0 font-semibold text-xl" style="font-size: 12px; color:#fff;">

                                            {{ slotPropsUltimosVendidosHoy.data.linea }}
                                        </div>
                                        <div class="mt-0 font-semibold text-xl" style="font-size: 12px; color:#ff9900;">
                                            <router-link
                                                :to="{ name: 'detalleProducto', query: { claveprod: slotPropsUltimosVendidosHoy.data.k_parte } }"
                                                style="font-size:22px;border: none;color:#06283c; text-decoration: none; color: inherit;">
                                                {{ slotPropsUltimosVendidosHoy.data.k_parte }}
                                            </router-link>

                                        </div>
                                    </div>
                                </div>
                            </template>
                        </Carousel>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Carousel from 'primevue/carousel';
import 'primevue/resources/themes/saga-blue/theme.css'
//import 'primevue/resources/themes/aura-light-green/theme.css'
export default {
    name: 'TemplateWithColumns',
    components: {
        Carousel,

    },
    props: {

    },
    data() {
        return {
            settings: {
                itemsToShow: 1,
                snapAlign: 'center',
            },
            breakpoints: {
                // 700px and up
                700: {
                    itemsToShow: 4,
                    snapAlign: 'center',
                },
                // 1024 and up
                1024: {
                    itemsToShow: 6,
                    snapAlign: 'start',
                },
            },
            losmasvistosprods: [],
            masbuscados: [],
            prodsultmasvend: [],
            prodsultmasvendhoy: [],
        };
    },

    methods: {
        getImagePath(relativePath) {
            return `${window.location.origin}/${relativePath}`;
        },
        losmasvistos() {
            //console.log('Initial:', this.losmasvistosprods.length); // Debería mostrar 0
            axios.get('/homedestacados/bannerdestacado').then((response) => {
                //console.log('contar')
              //  console.log(response.data)
                this.losmasvistosprods = response.data
                //console.log('After API Call:', this.losmasvistosprods.length); // Debería mostrar la longitud actualizada
            }).catch((error) => {
                console.log(error)
            });
        },
    },
    mounted() {

        this.losmasvistos();

    }
};
</script>

<style scoped>
.box {
    position: relative;
    background: #fff;
    box-shadow: 0 0 15px rgba(0, 0, 0, 0.4);
}

/* la base */
.badge {
    width: 150px;
    height: 150px;
    overflow: hidden;
    position: absolute;
}

.badge::before,
.badge::after {
    position: absolute;
    z-index: -1;
    content: "";
    display: block;
    border: 5px solid #06283c;
}

.badge span {
    position: absolute;
    display: block;
    width: 225px;
    padding: 15px 0;
    background-color: #06283c;
    box-shadow: 0 5px 10px rgba(0, 0, 0, 0.1);
    color: #ff9900;
    font: 700 18px/1 "Lato", sans-serif;
    text-shadow: 0 1px 1px rgba(0, 0, 0, 0.2);
    text-transform: uppercase;
    text-align: center;
}

/* in alto a destra */
.badge-top-right {
    top: -10px;
    right: -10px;
}

.badge-top-right::before,
.badge-top-right::after {
    border-top-color: transparent;
    border-right-color: transparent;
}

.badge-top-right::before {
    top: 0;
    left: 0;
}

.badge-top-right::after {
    bottom: 0;
    right: 0;
}

.badge-top-right span {
    left: -25px;
    top: 30px;
    transform: rotate(45deg);
}

.nopadding {
    padding: 0 !important;
    margin: 0 !important;
}
.opacity-and-blur {
    transition: opacity 0.5s ease, filter 0.5s ease;
}

.opacity-and-blur:hover {
    opacity: 0.7;
    filter: blur(2px);
}
</style>